/**
 * React Query Setup
 * Provides QueryClient and default options
 */

import { QueryClient } from '@tanstack/react-query';

// Create a client with default options
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache data for 10 minutes (data is fresh for 10 minutes)
      staleTime: 10 * 60 * 1000,
      // Keep unused data in cache for 30 minutes (garbage collection time)
      gcTime: 30 * 60 * 1000, // formerly cacheTime
      // Retry failed requests once (reduce retries for faster failure)
      retry: 1,
      // Don't refetch on window focus for better UX
      refetchOnWindowFocus: false,
      // Refetch on mount if data is stale, but cached data is shown immediately
      refetchOnMount: true,
      // Don't refetch on reconnect if data is fresh
      refetchOnReconnect: false,
      // Don't pause queries when tab is not visible
      networkMode: 'always',
      // Suspense mode off (don't block rendering)
      suspense: false,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
      // Don't pause mutations
      networkMode: 'always',
    },
  },
});

